// extracted by mini-css-extract-plugin
export var chevron = "Accordion-module--chevron--c22bc";
export var content = "Accordion-module--content--b02c0";
export var label = "Accordion-module--label--a46d5";